export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'
export const CLEAR_PORTS_MESSAGE = 'CLEAR_PORTS_MESSAGE'
export const CREATE_SHEETS = 'CREATE_SHEETS'
export const GET_AUTOMATION_TYPES = 'GET_AUTOMATION_TYPES'
export const CREATE_OPEN_PORT_SHEET = 'CREATE_OPEN_PORT_SHEET'
export const GET_WORKSPACES = 'GET_WORKSPACES'
export const GET_WORKSPACE_FOLDERS = 'GET_WORKSPACE_FOLDERS'
export const GET_ACTIVE_SHEETS = 'GET_ACTIVE_SHEETS'
